import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgLock = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path d="M19.501 10.875h-1.594v-5.25a3 3 0 00-3-3H9.095a3 3 0 00-3 3v5.25H4.5a.75.75 0 00-.75.75v9c0 .415.335.75.75.75h15a.75.75 0 00.75-.75v-9a.75.75 0 00-.75-.75zm-6.844 5.555v1.242a.188.188 0 01-.187.187h-.938a.188.188 0 01-.187-.187V16.43a1.126 1.126 0 111.312 0zm3.563-5.555H7.782v-5.25c0-.724.589-1.313 1.313-1.313h5.812c.724 0 1.313.589 1.313 1.313v5.25z" />
    </Icon>
  );
};

export default SvgLock;
